export default __webpack_public_path__ + "static/media/Band of the Twice-Conquered.83aee180.jpg";